import axios from "axios";
import { host } from "../endPoints";
import md5 from "md5";
import { userToken, adminUserToken } from "./tokens";
import { onsiteHeader } from "venuescanner-js/routes/constants-es";

const send = {
  get: (url, data, { headers }) => {
    return axios.get(url, { params: data, headers });
  },
  post: (url, data, { headers, onUploadProgress }) => {
    return axios.post(url, data, { headers, onUploadProgress });
  },
  put: (url, data, { headers }) => {
    return axios.put(url, data, { headers });
  },
  patch: (url, data, { headers }) => {
    return axios.patch(url, data, { headers });
  },
  delete: (url, data, { headers }) => {
    return axios.delete(url, { data, headers });
  },
};

const urlParse = ({ name, path, data = {}, removeFromData = false }) => {
  return (
    host +
    path
      .split("/")
      .map((part) => {
        if (part.match(/^:/)) {
          const key = part.replace(/^:/, "");
          if (!data[key])
            throw new Error(`Missing ${key} parameter in the data for ${name}`);
          const val = data[key];
          if (removeFromData) delete data[key];
          return val;
        } else {
          return part;
        }
      })
      .join("/")
  );
};
const headersParse = ({ url, data, asAdmin, onsite }) => {
  const headers = {
    Accept: "application/json",
  };
  const _userToken = userToken();
  const _adminUserToken = adminUserToken();
  if (_userToken) {
    headers["X-Access-Token"] = _userToken;
  }
  if (_adminUserToken && _adminUserToken !== _userToken) {
    if (asAdmin) {
      headers["X-Access-Token"] = _adminUserToken;
    } else {
      headers["X-Admin-Access-Token"] = _adminUserToken;
    }
  }
  if (data && !(data instanceof FormData))
    headers["Content-Type"] = "application/json";

  if (onsite) {
    headers[onsiteHeader] = md5(url);
  }
  return headers;
};

const apiCall = (name, type, schema, asAdmin) => {
  return async (data = {}, { asAdmin, files, onProgress } = {}) => {
    const { onsite, path } = schema;
    const url = urlParse({ name, path, data, removeFromData: type === "get" });
    const headers = headersParse({ url, data, asAdmin, onsite });
    if (files instanceof File) files = [files];
    if (files && files.length) {
      const formData = new FormData();
      formData.append("file", files[0]);
      Object.keys(data).forEach((key) => {
        formData.append(key, data[key]);
      });
      const response = await send[type](url, formData, {
        headers,
        onUploadProgress: function (progressEvent) {
          let percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          if (onProgress) onProgress(percentCompleted);
        },
      });
      return response.data;
    } else {
      const response = await send[type](url, data, { headers });
      return response.data;
    }
  };
};
const methodBuilder = (name, schema) => {
  const { methods = ["get"] } = schema;
  return methods.reduce((acc, method) => {
    acc[method] = apiCall(name, method, schema);
    return acc;
  }, {});
};
export default methodBuilder;
